import api from './api';
import axios from "../../axios";
import { getApiErrorInfo } from "../../utilis/api-error";

const API_PREFIX = "api/question";

const getAllQuestions = async (params) => {
    const response = await api.get(`${API_PREFIX}/set`, { params });
    return response;
};

const getAccountQuestionsAPI = async (params) => {
    const response = await api.get(`${API_PREFIX}/account/questions`, { params });
    if (response && response.length > 0) {
        return response.filter(ele => !ele?.question?.isDefaultCard && !ele?.question?.existingAccessor);
    }
    return response;
};

const saveSelectedQuestionsAPI = async (body) => {
    const response = await api.post(`${API_PREFIX}/clone-account-question`, body);
    return response;
};

const removeArchivedQuestionsAPI = async (id) => {
    const response = await api.delete(`${API_PREFIX}/remove-archived-questions/${id}`);
    return response;
};

const getAutoFillSourceQuestionsAPI = async (params) => {
    const response = await api.get(`${API_PREFIX}/auto-fill-sources`, { params });
    return response;
};

const updateAutoFillSettingsAPI = async (questionId, autoFillData) => {
    const response = await api.put(`${API_PREFIX}/auto-fill-settings/${questionId}`, autoFillData);
    return response;
};

/**
 * Submit question form data to backend
 * @param {Object} questionData - Question form data
 * @param {string} questionData.question - The user's question
 * @param {string} questionData.name - User's name
 * @param {string} questionData.email - User's email
 * @param {string} questionData.organization - Organization name (optional)
 * @returns {Promise<Object>} Response from the backend
 */
export const submitQuestionForm = async (questionData) => {
  try {
    const response = await axios.post('/api/questions/submit', {
      question: questionData.question,
      name: questionData.name,
      email: questionData.email,
      organization: questionData.organization,
      source: 'ask-question-page', // To identify where the form was submitted from
      submittedAt: new Date().toISOString()
    });

    return {
      success: true,
      data: response.data,
      message: 'Question submitted successfully'
    };
  } catch (error) {
    console.error('Question form API error:', error);
    
    // Handle different error scenarios
    if (error.response) {
      const { message } = getApiErrorInfo(error);
      return {
        success: false,
        error: error.response.data,
        message: message || 'Server error occurred',
        status: error.response.status
      };
    } else if (error.request) {
      // Request was made but no response received
      return {
        success: false,
        error: 'No response from server',
        message: 'Unable to connect to server. Please check your internet connection.',
      };
    } else {
      // Something else happened
      return {
        success: false,
        error: error.message,
        message: 'An unexpected error occurred. Please try again.',
      };
    }
  }
};

export {
    getAllQuestions,
    saveSelectedQuestionsAPI,
    getAccountQuestionsAPI,
    removeArchivedQuestionsAPI,
    getAutoFillSourceQuestionsAPI,
    updateAutoFillSettingsAPI
};
